/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './hack-results.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../shared/components/hack-results-viewer/hack-results-viewer.module.ngfactory';
import * as i3 from '../../../../../../src/app/components/client/shared/components/hack-results-viewer/hack-results-viewer.module';
import * as i4 from '../../../../../../src/app/components/client/shared/services/shared-export.service';
import * as i5 from '@angular/common';
import * as i6 from '../../../../../../src/app/components/client/hack-results/hack-results.component';
import * as i7 from '@angular/router';
import * as i8 from '../../../../../../src/app/providers/auth.service';
import * as i9 from '../../../../../../src/app/components/client/shared/services/shared-candidate.service';
import * as i10 from '../../../../../../src/app/components/client/shared/services/shared-hack.service';
const styles_HackResultsComponent:any[] = [i0.styles];
export const RenderType_HackResultsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HackResultsComponent,data:{}});
function View_HackResultsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'hack-results-viewer',
      ([] as any[]),[[2,'pdf-mode',(null as any)]],(null as any),(null as any),i2.View_HackResultsViewerComponent_0,
      i2.RenderType_HackResultsViewerComponent)),i1.ɵdid(4308992,(null as any),0,i3.HackResultsViewerComponent,
      [i4.SharedExportService],{hackResults:[0,'hackResults'],hackReports:[1,'hackReports'],
          candidate:[2,'candidate'],uiEventsReport:[3,'uiEventsReport'],pdfMode:[4,
              'pdfMode']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.hackResults;
    const currVal_2:any = _co.hackReports;
    const currVal_3:any = _co.candidate;
    const currVal_4:any = _co.uiEventsReport;
    const currVal_5:any = true;
    _ck(_v,1,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).pdfModeClass;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_HackResultsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_HackResultsComponent_1)),i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i6.HackResultsComponent = _v.component;
    const currVal_0:any = _co.hackResults;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_HackResultsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_HackResultsComponent_0,
      RenderType_HackResultsComponent)),i1.ɵdid(114688,(null as any),0,i6.HackResultsComponent,
      [i7.ActivatedRoute,i7.Router,i8.AuthService,i9.SharedClientCandidateService,
          i10.SharedHackService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HackResultsComponentNgFactory:i1.ComponentFactory<i6.HackResultsComponent> = i1.ɵccf('ng-component',
    i6.HackResultsComponent,View_HackResultsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9oYWNrLXJlc3VsdHMvaGFjay1yZXN1bHRzLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9jbGllbnQvaGFjay1yZXN1bHRzL2hhY2stcmVzdWx0cy5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9jbGllbnQvaGFjay1yZXN1bHRzL2hhY2stcmVzdWx0cy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9oYWNrLXJlc3VsdHMvaGFjay1yZXN1bHRzLmNvbXBvbmVudC50cy5IYWNrUmVzdWx0c0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxoYWNrLXJlc3VsdHMtdmlld2VyICpuZ0lmPVwiaGFja1Jlc3VsdHNcIlxuXHRbcGRmTW9kZV09XCJ0cnVlXCJcblx0W2hhY2tSZXN1bHRzXT1cImhhY2tSZXN1bHRzXCJcblx0W2hhY2tSZXBvcnRzXT1cImhhY2tSZXBvcnRzXCJcblx0W3VpRXZlbnRzUmVwb3J0XT1cInVpRXZlbnRzUmVwb3J0XCJcblx0W2NhbmRpZGF0ZV09XCJjYW5kaWRhdGVcIlxuPjwvaGFjay1yZXN1bHRzLXZpZXdlcj5cbiIsIjxuZy1jb21wb25lbnQ+PC9uZy1jb21wb25lbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTs4Q0FBQSxVQUFBO01BQUE7VUFBQTtjQUFBOztJQUVDO0lBQ0E7SUFFQTtJQURBO0lBSEE7SUFERCxXQUVDLFVBQ0EsVUFFQSxVQURBLFVBSEEsU0FERDs7SUFBQTtJQUFBLFdBQUEsU0FBQTs7OztvQkFBQTtNQUFBLHFDQUFBO29CQUFBLG1DQU11QjtNQUFBOztJQU5GO0lBQXJCLFdBQXFCLFNBQXJCOzs7O29CQ0FBO01BQUE7cUNBQUEsVUFBQTtNQUFBOytCQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/client/hack-results/hack-results.component.ngfactory.ts